import { reviewDesignAssetUsage } from '../design-tokens';

/** Count affected blocks across the current version, including nested and reusable symbols. */
export function countAssetReferencingBlocks(data: unknown, assetId: string): number {
	const ids = new Set<string>();
	const visit = (value: unknown): void => {
		if (!value || typeof value !== 'object') return;
		if (Array.isArray(value)) {
			value.forEach(visit);
			return;
		}
		const node = value as Record<string, unknown>;
		if (
			typeof node._id === 'string' &&
			node.uiConfig &&
			reviewDesignAssetUsage(node.uiConfig).unknownReferences.includes(assetId)
		)
			ids.add(node._id);
		Object.values(node).forEach(visit);
	};
	visit(data);
	return ids.size;
}
